import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import ConfigsContext from '../../../contextProviders/ConfigsContext';
import FormInput from '../../../commonComponents/forms/FormInput';
import TextFilter from '../../../commonComponents/lists/filters/TextFilter';
import translate from '../../../commonComponents/translate';
import CustomCheckbox from '../../../commonComponents/forms/inputs/CustomCheckbox';
import AsyncDateRange from '../../../commonComponents/forms/inputs/AsyncDateRange';

function NetworkListFilters(props) {
  const {
    t,
    filters,
    onFiltersChange,
    onExportList,
    onDateChange,
    onClearFilters,
  } = props;

  const configs = useContext(ConfigsContext);
  const { skillLevels } = configs?.organization || {};

  const skillLevelsList = useMemo(
    () =>
      Object.keys(skillLevels).map(level => ({
        id: level,
        text: skillLevels[level]?.name || '-',
      })),
    [skillLevels],
  );

  return (
    <div className="networkFilters">
      <div className="filter_wrapper flex_1">
        <TextFilter
          id="searchInput"
          onChange={onFiltersChange('search')}
          placeholder={t('search.user')}
          value={filters.search}
        />
      </div>
      <div className="filter_wrapper flex_1">
        <FormInput
          id="sponsoredBy"
          name="sponsoredBy"
          placeholder={t('sponsor')}
          value={filters.sponsoredBy}
          onChange={onFiltersChange('sponsoredBy')}
          type="users"
          inputProps={{
            allowClear: true,
            url: '/user/table/network/list',
          }}
        />
      </div>
      <div className="filter_wrapper flex_1">
        <FormInput
          id="recruitedBy"
          name="recruitedBy"
          placeholder={t('recruiter')}
          value={filters.recruitedBy}
          onChange={onFiltersChange('recruitedBy')}
          type="users"
          inputProps={{
            allowClear: true,
          }}
        />
      </div>
      <div className="filter_wrapper flex_1">
        <FormInput
          id="level"
          name="level"
          placeholder={t('user.level')}
          value={filters.level}
          onChange={onFiltersChange('level')}
          type="select2"
          inputProps={{
            allowClear: true,
            items: skillLevelsList,
          }}
        />
      </div>
      <div className="col-lg-4 col-12">
        <AsyncDateRange
          id="filterDate"
          startDate={filters.startDate}
          endDate={filters.endDate}
          placeholder={t('commissions.filter_date_placeholder')}
          onChange={({ startDate, endDate, rangeType }) => {
            onDateChange(startDate, endDate, rangeType);
          }}
          opens="left"
          onClear={onClearFilters}
        />
      </div>
      <div className="filter_wrapper flex_1 networkChecked">
        <CustomCheckbox
          id="showInvited"
          label={t('reports.scorm.showInvited')}
          checked={filters.showInvited}
          onClick={onFiltersChange('showInvited')}
        />
      </div>
      <div className="filter_wrapper flex_1 btn_export">
        <button
          type="button"
          onClick={() => onExportList()}
          className="btn btn-excel-export btn-sm"
        >
          {t('excel.export.list')}
        </button>
      </div>
    </div>
  );
}

NetworkListFilters.propTypes = {
  t: PropTypes.func.isRequired,
  filters: {
    search: PropTypes.string,
    sponsoredBy: PropTypes.string,
    recruitedBy: PropTypes.string,
    level: PropTypes.string,
    status: PropTypes.string,
    user: PropTypes.string,
  },
  onFiltersChange: PropTypes.func.isRequired,
  onExportList: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
};

NetworkListFilters.defaultProps = {
  filters: {
    search: null,
    sponsoredBy: null,
    recruitedBy: null,
    level: null,
    status: null,
    user: null,
  },
};

export default translate(NetworkListFilters);
